export enum CostFrequency {
    ONCE = "once",
    DAILY = "daily",
    MONTHLY = "monthly",
    YEARLY = "yearly",
}